module.exports = __webpack_public_path__ + "img/antes_despues_35.a7a1b9a7.png";